import classNames from 'classnames'
import { Alert } from '@cmsgov/ds-medicare-gov'
import { Button } from 'components/Button/Button'
import { ReactComponent as CloseIcon } from 'images/Icon_Close.svg'
import classes from './HomeToastAlert.module.scss'
import { useEffect } from 'react'

type HomeToastAlertProps = {
  className?: string
  content: string
  subject: string
  onClose?: () => void
  onLinkClick?: (args: { linkUrl: string; linkText: string }) => void
  onRender?: () => void
}

export const HomeToastAlert = ({
  className,
  content,
  subject,
  onClose,
  onLinkClick,
  onRender
}: HomeToastAlertProps) => {
  // Handler for allowing callback for clicks of links within content
  const contentLinkRefHandler = (ref: HTMLDivElement) => {
    ref?.querySelectorAll('a').forEach((anchorElement: HTMLAnchorElement) => {
      anchorElement.onclick = (e) => {
        const { href: linkUrl, innerText: linkText } = anchorElement

        onLinkClick?.({ linkUrl, linkText })
      }
    })
  }

  // Used for firing events when alert is shown
  useEffect(() => onRender?.(), []) // eslint-disable-line

  return (
    <Alert
      className={classNames(
        'my-u-width--full ds-u-fill--white',
        classes.outer,
        className
      )}
      heading={subject}
    >
      <div className="ds-u-display--flex ds-u-align-items--start ds-u-justify-content--between my-u-width--full">
        <div
          className={classNames('my-u-flex-grow-1', classes.content)}
          ref={contentLinkRefHandler}
          dangerouslySetInnerHTML={{ __html: content }}
        ></div>

        {onClose && (
          <Button
            className={classNames(
              'ds-c-button ds-c-button--ghost ds-u-border--0 ds-u-padding--0',
              classes.close
            )}
            onClick={onClose}
          >
            <CloseIcon />
          </Button>
        )}
      </div>
    </Alert>
  )
}
